module.exports = __WEBPACK_EXTERNAL_MODULE_8__;


//////////////////
// WEBPACK FOOTER
// external "@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"
// module id = 8
// module chunks = 0